RivalIQ.apps.Dashboard.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const SectionHeader = RivalIQ.views.ItemView.mixin({
        className: function () {
            const me = this;

            return `section-header-widget ${me.anchorName()}`;
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        template: '#dashboardSectionHeaderWidgetTemplate',

        anchorName: function () {
            const me = this;

            return me.getProp('anchorName') || _.kebabCase(me.getProp('sectionHeaderName'));
        },

        serializeData: function () {
            const me = this;

            return {
                sectionHeaderName: me.getProp('sectionHeaderName')
            };
        },

        onAttachLoaded: function () {
            const me = this;

            if (!me.dashboardModel.isExporting() && me.getProp('scrollToSection') === me.anchorName()) {
                const contentContainerTop = $('#content-region').offset().top;
                const scrollOffset = me.$el.offset().top - contentContainerTop;
                $([document.documentElement]).animate({
                    scrollTop: scrollOffset
                }, 500);
            }
        }
    });

    const SectionHeaderWidget = RivalIQ.apps.Dashboard.models.Widget.extend({
        view: SectionHeader,
        viewMore: false,
        panelView: App.views.ChromelessPanel,
        panelClassName: 'bare',

        // no section headers in PPT.
        getSlides: function (overrides) {
            return [];
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.SECTION_HEADER, SectionHeaderWidget);
});
